import React from 'react';
import type { AppState } from '../types';
import { PageShell, EmptyState, usePagination, Pagination, T } from '../ui';
export function Alertas({
  state,
  resolveAlert
}: {
  state: AppState;
  resolveAlert: (id: string) => void;
}) {
  const alerts = state.meds.filter(m => state.notif.fueraRango && m.lux < state.prefs.luxMin && !state.dismissedAlerts.includes(m.id));
  const {
    page,
    setPage,
    totalPages,
    pageItems,
    rangeStart,
    rangeEnd,
    total
  } = usePagination(alerts, 8);
  return <PageShell title="Alertas" sub="Mediciones fuera del rango mínimo configurado" data-id="element-113" data-mp="b10qo2eil7hn">
      
      <style data-id="element-114" data-mp="fysg8proshio">{`
        .alert-card {
          background: ${T.surface};
          border: 1px solid ${T.border};
          border-left: 3px solid ${T.danger};
          border-radius: ${T.rMd}px;
          box-shadow: ${T.innerHi};
          padding: 16px 18px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          gap: 16px;
          transition: border-color .2s, background .2s, transform .2s;
        }
        .alert-card:hover { background: ${T.surfaceHover}; transform: translateY(-2px); }
        .alert-list > * { animation: fadeUp .35s ease both; }
        .resolve-btn {
          background: ${T.okSoft};
          border: 1px solid rgba(74,222,128,.25);
          border-radius: ${T.rMd}px;
          padding: 8px 16px;
          color: ${T.ok};
          font-weight: 700;
          font-size: 13px;
          cursor: pointer;
          white-space: nowrap;
          font-family: inherit;
          transition: background .15s;
          flex-shrink: 0;
        }
        .resolve-btn:hover { background: rgba(74,222,128,.2); }
        @media (max-width: 640px) {
          .alert-card { flex-wrap: wrap; align-items: flex-start; gap: 12px; padding: 14px; }
          .alert-card .alert-meta { text-align: left !important; margin-right: 0 !important; }
          .resolve-btn { width: 100%; }
        }
      `}</style>

      {alerts.length === 0 ? <EmptyState title="Sin alertas activas" accent={T.ok} hint={`Todas las mediciones están dentro del rango mínimo de ${state.prefs.luxMin} lx`} icon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-116" data-mp="tb27p29qmfxn">
          
              <circle cx="12" cy="12" r="10" data-id="element-117" data-mp="yaeszikyney4" />
              <polyline points="9 12 11 14 15 10" data-id="element-118" data-mp="1lzzg8do5cyd7" />
            </svg>} data-id="element-115" data-mp="138gbo2eh5c92" /> : <>
          <div style={{
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        background: T.surface,
        border: `1px solid ${T.border}`,
        borderLeft: `3px solid ${T.warn}`,
        borderRadius: T.rMd,
        padding: '12px 16px',
        fontSize: 13,
        color: T.warn,
        fontWeight: 600,
        boxShadow: T.innerHi
      }} data-id="element-119" data-mp="1lxwqluqwp790">
          
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-120" data-mp="1lz3tnlrj7lj">
            
              <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" data-id="element-121" data-mp="3u61mm4wq0luy" />
              <line x1="12" y1="9" x2="12" y2="13" data-id="element-122" data-mp="3p802rhrh0iif" />
              <line x1="12" y1="17" x2="12.01" y2="17" data-id="element-123" data-mp="80o2ki0zi93j" />
            </svg>
            {alerts.length} medición{alerts.length > 1 ? 'es' : ''} por debajo
            de {state.prefs.luxMin} lx
          </div>

          <div className="alert-list" style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 8
      }} data-id="element-124" data-mp="3bg21ft403qwt">
          
            {pageItems.map(m => {
          const suc = state.sucs.find(s => s.id === m.sucursalId);
          const diff = state.prefs.luxMin - m.lux;
          return <div key={m.id} className="alert-card" data-id="element-125" data-mp="3gfo97n128ey8">
                  <div style={{
              display: 'flex',
              gap: 14,
              alignItems: 'center',
              flex: 1
            }} data-id="element-126" data-mp="3ge3f1yinqy0w">
                  
                    <div style={{
                width: 44,
                height: 44,
                borderRadius: T.rMd,
                flexShrink: 0,
                background: T.dangerSoft,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }} data-id="element-127" data-mp="2nr0njqcefnk5">
                    
                      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke={T.danger} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" data-id="element-128" data-mp="24rtqxozsrps3">
                      
                        <line x1="9" y1="18" x2="15" y2="18" data-id="element-129" data-mp="2ep7z71bkh89b" />
                        <line x1="10" y1="22" x2="14" y2="22" data-id="element-130" data-mp="2erkpc1rhaoxg" />
                        <path d="M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0 0 18 8 6 6 0 0 0 6 8c0 1 .23 2.23 1.5 3.5A4.61 4.61 0 0 1 8.91 14" data-id="element-131" data-mp="2is4mv6fyruk4" />
                      </svg>
                    </div>
                    <div data-id="element-132" data-mp="oec22gs9wiwt">
                      <div style={{
                  fontWeight: 700,
                  color: T.text,
                  fontSize: 14,
                  marginBottom: 4
                }} data-id="element-133" data-mp="oevbta7rs0zr">
                      
                        {m.punto}
                      </div>
                      <div style={{
                  fontSize: 12,
                  color: T.textSecondary
                }} data-id="element-134" data-mp="h145kyaj4ue7">
                      
                        {suc?.nombre ?? 'Sucursal desconocida'}
                      </div>
                    </div>
                  </div>
                  <div className="alert-meta" style={{
              textAlign: 'right',
              flexShrink: 0,
              marginRight: 16
            }} data-id="element-135" data-mp="14qf9gon6f4wk">
                  
                    <div style={{
                fontWeight: 800,
                color: T.danger,
                fontSize: 20,
                lineHeight: 1
              }} data-id="element-136" data-mp="usj0o3hpom1m">
                    
                      {m.lux} lx
                    </div>
                    <div style={{
                fontSize: 11,
                color: T.textMuted,
                marginTop: 3
              }} data-id="element-137" data-mp="3fh6pn5wqpgsj">
                    
                      -{diff} lx del mínimo
                    </div>
                  </div>
                  <button className="resolve-btn" onClick={() => resolveAlert(m.id)} data-id="element-138" data-mp="3hwve567junz5">
                  
                    Resolver
                  </button>
                </div>;
        })}
          </div>
          <Pagination page={page} totalPages={totalPages} onChange={setPage} rangeStart={rangeStart} rangeEnd={rangeEnd} total={total} label="alertas" data-id="element-139" data-mp="37yfkowl1v2mh" />
        
        </>}
    </PageShell>;
}